<form [formGroup]="discountDetailsForm">
    <div class="modal-dialog modal-dialog-centered detail-modal">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">Discount Upload Info.</h4>
                <button type="button" class="btn-close" aria-label="Close"
                    (click)="activeModal.dismiss('Cross click')"></button>
            </div>
            <div class="modal-body">
                <div class="card">
                    <div class="card-body">
                        <div class="row mt-5 mb-4">
                            <div class="col-md-3">
                                <div class="mb-2">
                                    <label for="formVendor" class="form-label">Vendor</label>
                                    <ng-select id="formVendor" formControlName="ddlVendor" placeholder="Select"
                                        [items]="vendorList" bindLabel="name" [bindValue]="'id'"
                                        [appendTo]="'ngb-modal-window'" [openOnEnter]="false" (change)="bindVendorService()"
                                        class="ng-select ng-select-single ng-select-searchable ng-select-clearable ng-select-bottom"
                                        [ngClass]="{'is-invalid': (isFormSubmitted || discountDetailsForm.get('ddlVendor').touched) && discountDetailsForm.get('ddlVendor').errors}" >
                                        <ng-template ng-option-tmp let-item="item" let-disabled="item.disabled">
                                            <span>{{ item.name }}</span>
                                        </ng-template>
                                    </ng-select>
                                    <div *ngIf="(isFormSubmitted || discountDetailsForm.get('ddlVendor').touched) && discountDetailsForm.get('ddlVendor').errors"
                                        class="invalid-feedback">
                                        <span *ngIf="discountDetailsForm.get('ddlVendor').errors.required">Vendor is
                                            Required</span>
                                    </div>
                                </div>
                            </div>

                            <div class="col-md-3">
                                <div class="mb-2">
                                    <label for="service" class="form-label">Service</label>
                                    <ng-select id="service" formControlName="ddlService" placeholder="Select"
                                        [items]="serviceList" bindLabel="servicename" [bindValue]="'id'"
                                        [appendTo]="'ngb-modal-window'" [openOnEnter]="false"
                                        class="ng-select ng-select-single ng-select-searchable ng-select-clearable ng-select-bottom"
                                        [ngClass]="{'is-invalid': (isFormSubmitted || discountDetailsForm.get('ddlService').touched) && discountDetailsForm.get('ddlService').errors}">
                                        <ng-template ng-option-tmp let-item="item" let-disabled="item.disabled">
                                            <span>{{ item.name }}</span>
                                        </ng-template>
                                    </ng-select>
                                    <div *ngIf="(isFormSubmitted || discountDetailsForm.get('ddlService').touched) && discountDetailsForm.get('ddlService').errors"
                                        class="invalid-feedback">
                                        <span *ngIf="discountDetailsForm.get('ddlService').errors.required">Service is
                                            Required</span>
                                    </div>
                                </div>
                            </div>

                            <div class="col-md-3">
                                <div class="mb-2">
                                    <label for="calculationby" class="form-label">Calculation By</label>
                                    <ng-select id="calculationby" formControlName="ddlCalculationBy"
                                        placeholder="Select" [items]="calculationByList" [appendTo]="'ngb-modal-window'" [openOnEnter]="false"
                                        [ngClass]="{'is-invalid': (isFormSubmitted || discountDetailsForm.get('ddlCalculationBy').touched) && discountDetailsForm.get('ddlCalculationBy').errors}">
                                    </ng-select>
                                    <div *ngIf="(isFormSubmitted || discountDetailsForm.get('ddlCalculationBy').touched) && discountDetailsForm.get('ddlCalculationBy').errors"
                                        class="invalid-feedback">
                                        <span
                                            *ngIf="discountDetailsForm.get('ddlCalculationBy').errors.required">Service
                                            is Required</span>
                                    </div>
                                </div>
                            </div>

                            <div class="col-md-3">
                                <div class="mb-2">
                                    <label for="amount" class="form-label">Amount<span
                                            class="mandatory">*</span></label>
                                    <input type="number" formControlName="txtAmount" id="amount"
                                        class="form-control form-control-sm ng-untouched ng-pristine ng-valid"
                                        ng-reflect-name="weight"
                                        [ngClass]="{'is-invalid': (isFormSubmitted || discountDetailsForm.get('txtAmount')?.touched) && discountDetailsForm.get('txtAmount').errors}" >
                                    <div *ngIf="(isFormSubmitted || discountDetailsForm.get('txtAmount')?.touched) && discountDetailsForm.get('txtAmount').errors"
                                        class="invalid-feedback">
                                        <span *ngIf="discountDetailsForm.get('txtAmount').errors.required">Amount is
                                            Required</span>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="submit" class="btn btn-primary" data-dismiss="modal"
                    (click)="updateDiscountDetails()" (keydown.enter)="useEnterKey ? $event.preventDefault() : updateDiscountDetails()"
                    >Update</button>
            </div>
        </div>
    </div>
</form>